import './Feedback.scss';
import { TranslationKey, useTranslator } from '@Localization';
import { observer } from 'mobx-react-lite';
import { PropsWithChildren, ReactElement } from 'react';
import { ColumnLayout } from '../../modules/common/layouts/columnLayout/ColumnLayout';

interface IProps extends PropsWithChildren {
  feedbacks?: TranslationKey[];
  feedbackParams?: Record<string, string | number | null>;
}

export const Feedback = observer((props: IProps): ReactElement => {
  const { t } = useTranslator();

  const renderFeedbacks = (): ReactElement => {
    const uniqueFeedbacks = props.feedbacks ? Array.from(new Set(props.feedbacks)) : [];
    return (
      <>
        {uniqueFeedbacks.map((feedback, i) => {
          return (
            <div key={i}>
              <>{t(feedback, props.feedbackParams || {})}</>
            </div>
          );
        })}
      </>
    );
  };

  return (
    <ColumnLayout
      size='sm'
      className='invalid-feedback'
    >
      {renderFeedbacks()}
      {props.children}
    </ColumnLayout>
  );
});
